import React from "react"
import { ClientesImg } from "../CarouselClientes/ClientesImg"
import loadable from "@loadable/component"

import "./landing.scss"

const CarouselClientes = loadable(() => import("../CarouselClientes"))



export const LandingSection = ({ classTitle, title }) => {
  return (
    <div className={`${classTitle}-wrapper-container`}>
      <div
        className={`${classTitle}-title-container`}
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <h1>{title}</h1>
      </div>
      <div
        className={`${classTitle}-carousel-container`}
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <CarouselClientes
          trim={true}
          cover={true}
          images={ClientesImg}
          fw1920="870px"
          fw1366="743px"
          fw1024="740px"
          fw768="524px"
          fw640="566px"
          fw360="342px"
          s1920="550px"
          s1366="477px"
          s1024="475px"
          s768="396px"
          s640="203px"
          s360="550px"
        />
      </div>
    </div>
  )
}
